import { Container, Sprite } from "pixi.js";
import { IScene, Manager } from "../core/Manager";
import { Reels } from "../reels/Reels";
// import { setSpinResponseDataGlobal } from "../config/GlobalVariableConfig";
import { FreeGameScene } from "./FreeGameScene";

import { Spine } from "@esotericsoftware/spine-pixi-v8";
import { sound, Sound } from "@pixi/sound";
import { Group, Tween } from "tweedle.js";
import { currentBackgorundMusicVolume, isMusicBtnOnGlobal, RespinIndex, setBackgorundMusic, setIsGameAlreadyLoaded, willBannerAutoProceedGlobal } from "../config/GlobalVariableConfig";
import { CasinoChannelHandler, casinoEventEmitter } from "../core/CasinoChannelHandler";
import { spinData } from "../server/getServerResposesFun";
import { BigWin } from "./BigWin";
// import { REEL_DIVIDER, REEL_FRAME, REEL_NUMBERS, REEL_WIDTH } from "../config/reelConfig";
// import { getSpineSymbol } from "../config/getSymbol";


import { reelSpinEmitter } from "../reels/ReelInit";

import { CharacterComponent } from "../components/character/CharacterComponent";
import { HighlightFramesComponent } from "../components/highlight/HighlightFramesComponent";
import { ReelComponent } from "../components/reels/ReelsComponent";
import { WindMillComonent } from "../components/windmill/WindMillFeatureComponent";
import { WinMeterComponent } from "../components/winmeters/WinMeterComponent";
import { isGameAlreadyLoaded } from "../config/GlobalVariableConfig";
import { DisplayComponent } from "../core/displays/DisplayComponent";
import { DisplayComponentFactory } from "../core/displays/DisplayComponentFactory";
import { DisplayObject } from "../core/displays/DisplayObject";
// import { wait } from "../utils";

declare const window: any;
// const translationManager = window.hacksawCasino.Translation;

// let hand: Spine;

// let tweenLogo: Tween<Spine>;
const tweenGroup: Group = new Group();

const logoPositionLandscape = {
    x: 1490,
    y: 1035,
    scale: 0.95
};
const logoPositionPortrait = {
    x: 1490,
    y: 1035,
    scale: 1
};

export class GameScene extends Container implements IScene {

    // Asset bundles
    assetBundles: string[] = ["game-screen", "sound", "intro-screen", "big-win"];

    // Containers
    private game = new Container();
    private reelFrame = new Container();

    private backgroundImageCont = new Container();
    private logo: Spine | null = null;
    // private logo: Sprite | null = null;

    private backgroundSpine: Spine | null = null;

    private gameIntro: Spine | null = null;

    private reels: Reels | null = null;
    // private banner: Banner | null = null;
    private bigWin: BigWin | null = null;

    private backgroundMusic: Sound | null = null;

    private freSpinTrigger: number = 0;
    private freSpinTriggerBaseWin: number = 0;

    private freeGameScene: FreeGameScene | null = null;

    private autoTriggerTimeout: ReturnType<typeof setTimeout>;

    private boundAnimateCharacter: () => void;
    private boundShakeEffect: () => void;

    private pointerDownHandlerBase: () => void;
    private idleCheckTicker?: ReturnType<typeof setInterval>;

    constructor() {
        super();

        this.setupEventListeners();

        this.boundAnimateCharacter = this.animateCharacter.bind(this);
        this.boundShakeEffect = this.shakeEffect.bind(this);

        this.pointerDownHandlerBase = this.onPointerDown.bind(this);

        reelSpinEmitter.off('animateCharacter', this.boundAnimateCharacter);
        reelSpinEmitter.off('shakeEffect', this.boundShakeEffect);
        reelSpinEmitter.off('triggerFeature', this.handleFeature, this);

        reelSpinEmitter.on('animateCharacter', this.boundAnimateCharacter);
        reelSpinEmitter.on('shakeEffect', this.boundShakeEffect);
        reelSpinEmitter.on('triggerFeature', this.handleFeature, this);

    }

    private setupEventListeners(): void {
        // casinoEventEmitter.on('roundEnded', this.handleRoundEnded.bind(this));
        casinoEventEmitter.on('roundStarted', this.handleRoundStarted.bind(this));
    }

    override  destroy() {
        // Unbind the event listener
        // casinoEventEmitter.off('betAccepted', this.handleBetAccepted.bind(this));

        console.log("inside override  destroy")

        reelSpinEmitter.off('animateCharacter', this.boundAnimateCharacter);
        reelSpinEmitter.off('shakeEffect', this.boundShakeEffect);
        reelSpinEmitter.off('triggerFeature', this.handleFeature, this);

        casinoEventEmitter.removeAllListeners('roundStarted');

        this.stopIdleCheck();
        DisplayComponent.unregister(CharacterComponent);
        DisplayComponent.unregister(HighlightFramesComponent);
        DisplayComponent.unregister(ReelComponent);
        DisplayComponent.unregister(WinMeterComponent);

        this.reels?.destroy(true);
        this.reels = null;

        super.destroy({ children: true, texture: false });
    }

    private animateCharacter(variant: string): void {
        DisplayComponent.get(CharacterComponent).animateCharacter(variant);
        // this.shakeEffect();
    }


    private shakeEffect() {

        console.log("inside shakeEffect");

        let duration = 250;
        let intensity = 20;

        const original = { x: this.x, y: this.y };
        const offset = { x: 0, y: 0 };

        const tween = new Tween(offset, tweenGroup)
            .to({ x: 0, y: 0 }, duration)
            .onUpdate(() => {
                this.x = original.x + (Math.random() - 0.5) * intensity;
                this.y = original.y + (Math.random() - 0.5) * intensity;
            })
            .onComplete(() => {
                this.x = original.x;
                this.y = original.y;
                tweenGroup.remove(tween);
            })
            .start();
    }

    private handleFeature(callback: () => void) {
        if (spinData.respins[RespinIndex.value].type === "windmill_reveal") {
            DisplayComponent.get(WindMillComonent).startWindMillFeature(callback);
        } else {
            callback();
        }
    }

    private async handleRoundStarted() {
        this.spinReel();


        if (!spinData.dataFeatched) {
            await this.waitForData();
        }

        Manager.casinoChannelHandler.reportResultDisplay();
    }

    private waitForData(): Promise<void> {
        return new Promise<void>((resolve) => {
            const checkInterval = setInterval(() => {
                if (spinData.dataFeatched) {
                    clearInterval(checkInterval);
                    resolve();
                }
            }, 100); // Check every 100ms

        });
    }

    private onPointerDown(): void {
        clearTimeout(this.autoTriggerTimeout);
        console.log("calling freeGameSceneChnage pointerdown");
        this.freeGameSceneChnage();

        Manager.banner.off('pointerdown', this.pointerDownHandlerBase);
    }

    public async constructorWithAssets(): Promise<void> {

        this.setupBackground();

        this.setupLogo();

        // this.setupBGSound();
        this.reels = new Reels();
        DisplayComponent.register(new DisplayComponentFactory(ReelComponent));
        DisplayComponent.get(ReelComponent).init();
        this.reels = DisplayComponent.get(ReelComponent).getInstance();

        if (isGameAlreadyLoaded) { // meaning coming from free game;
            this.setupReelFrame(false);
            // when coming from free-> base then music will be chnaged in the banner disappear

            // this.setupBGSound();

        }
        else {
            this.setupReelFrame(true);
            // the following will skip the intro in the game
            // this.setupReelFrame(false);
            // this.setupBGSound();
            // CasinoChannelHandler.reportGameStarted();
            // setIsGameAlreadyLoaded(true);
        }

        // this.setupCharacter();
        this.setupWindMillComponent();
        this.setupMeterContainer();
        this.bigWin = new BigWin(Manager.screenwidth, Manager.screenHeight);
        this.bigWin.position.set(Manager.screenwidth / 2, Manager.screenHeight / 2);
        this.addChild(this.bigWin);

        this.resize(Manager.screenwidth, Manager.screenHeight);

    }

    private setupBGSound() {
        this.backgroundMusic = sound.find('base_music_loop'); // initialize with ambient sound
        setBackgorundMusic(this.backgroundMusic);

        if (this.backgroundMusic) {
            this.backgroundMusic.loop = true;
            this.backgroundMusic.volume = 0;//currentBackgorundMusicVolume;
            // console.log("this.backgroundMusic.volume", this.backgroundMusic.volume);
            this.backgroundMusic.singleInstance = true;
            // this.backgroundMusic.speed = 0.5;
            this.backgroundMusic.play();

            this.backgroundMusic.muted = !isMusicBtnOnGlobal;

            const tween = new Tween(this.backgroundMusic, tweenGroup)
                .to({ volume: currentBackgorundMusicVolume }, 2000)
                .onComplete(() => {
                    tweenGroup.remove(tween);
                })
                .start();

        }
    }

    private callFreeGameSceneChnageAuto() {

        this.autoTriggerTimeout = setTimeout(() => {
            console.log("calling freeGameSceneChnage auto")
            clearTimeout(this.autoTriggerTimeout);
            this.freeGameSceneChnage();
        }, 10000); // 10 seconds
    }

    private setupWindMillComponent() {
        DisplayComponent.register(new DisplayComponentFactory(WindMillComonent));
        DisplayComponent.get(WindMillComonent).init();
    }

    private async spinReel(): Promise<void> {


        if (this.reels) {
            // DisplayComponent.get(WinMeterComponent).getInstance().resetMultipliers();
            const [freeGameTrigger, winAmount, accumulatedsWinAmount] = await this.reels.startPlay("BASE");
            console.log("in GameScene freeGameTrigger winAmount RespinIndex.value", freeGameTrigger, winAmount, RespinIndex.value);

            if (freeGameTrigger > 0 && Manager.banner) {

                this.freSpinTrigger = freeGameTrigger;
                this.freSpinTriggerBaseWin = winAmount;



                reelSpinEmitter.emit('animateCharacter');

                await this.reels?.processWinFeatureSymbol(RespinIndex.value - 1);

                Manager.casinoChannelHandler.reportFeatureEnter();

                await Manager.banner.appearFreeGameIntroBanner(this.freSpinTrigger);


                console.log("appearFreeGameIntroBanner");

                if (willBannerAutoProceedGlobal) {
                    this.callFreeGameSceneChnageAuto();
                }

                this.freeGameScene = new FreeGameScene(this.freSpinTrigger, this.freSpinTriggerBaseWin);
                await Manager.changeScene(this.freeGameScene, false);
                //attach a listner now
                Manager.banner.on('pointerdown', this.pointerDownHandlerBase);
                // this.freeGameSceneChnage(this.freSpinTrigger, this.freSpinTriggerBaseWin)
            }
            else if (winAmount === -1) {
                console.log("in Gamescene- Bet declined");
            }
            else {
                await this.bigWin?.bigWinFunction(accumulatedsWinAmount);
                // this.checkFeatures();
                Manager.casinoChannelHandler.reportGameRoundCompleted();
                // reportGameRoundCompleted();
            }

            if (freeGameTrigger === -2 || spinData.respins[RespinIndex.value]?.type === "max_win_reached") { // max win reached 
                Manager.casinoChannelHandler.reportMaxWin();
            }

            this.reels?.setReelRunning(false);
        }
    }

    // private checkFeatures() {
    //     if (RespinIndex.value > 0 && RespinIndex.value < spinData.respins.length) {

    //     } else {
    //         Manager.casinoChannelHandler.reportGameRoundCompleted();
    //     }
    // }

    private async freeGameSceneChnage() {

        await Manager.banner?.disappearBanner();

        this.freeGameScene?.freeSpinPlay();

    }

    private setupBackground(): void {

        // this.backgroundImageCont.addChild(Sprite.from('background'));
        this.addChild(this.backgroundImageCont);

        this.backgroundSpine = Spine.from({
            skeleton: "baseBackgroundSkel",
            atlas: "baseBackgroundAtlas",
        });

        this.backgroundSpine.position.set(3000 / 2, 3000 / 2);

        // spineSymbol.scale=0.1;

        this.backgroundImageCont.addChild(this.backgroundSpine);

        this.addChild(this.game);
    }

    private setupIntro(): void {

        this.gameIntro = Spine.from({
            skeleton: "gameIntroSkel",
            atlas: "gameIntroAtlas"
        })
        // this.gameIntro.alpha = 0.1;

        this.gameIntro.position.set(1500, 1500);
        this.gameIntro.label = "gameIntro";
        this.addChild(this.gameIntro);

        //const animations = this.gameIntro.skeleton.data.animations.map(anim => anim.name);
        // console.log("gameIntro Available animations:", animations);
        // console.log("this.gameIntro", this.gameIntro);
    }


    private setupLogo(): void {

        this.logo = Spine.from({
            skeleton: "logoSkel",
            atlas: "logoAtlas",
        });
        // this.logo = Sprite.from('logoStatic')
        this.logo.alpha = 0;
        this.logo.scale = 1;
        // this.logo.anchor = 0.5;


        this.game.addChild(this.logo);

        // this.logo.state.setAnimation(0, "animation", true);

        // const animations = this.logo.skeleton.data.animations.map(anim => anim.name);
        // console.log("Available animations:", animations);

    }

    private stopIdleCheck(): void {
        if (this.idleCheckTicker) {
            clearInterval(this.idleCheckTicker);
            this.idleCheckTicker = undefined;
        }
    }

    private setupCharacter(): void {
        DisplayComponent.register(new DisplayComponentFactory(CharacterComponent));
        DisplayComponent.get(CharacterComponent).init();
        let inst = DisplayComponent.get(CharacterComponent).getInstance();
        this.game.addChild(inst);
    }

    private setupMeterContainer(): void {
        DisplayComponent.register(new DisplayComponentFactory(WinMeterComponent));
        DisplayComponent.get(WinMeterComponent).init();
        let inst = DisplayComponent.get(WinMeterComponent).getInstance();
        this.game.addChild(inst);
    }

    private setupHighlightFrames(): void {
        DisplayComponent.register(new DisplayComponentFactory(HighlightFramesComponent));
        DisplayComponent.get(HighlightFramesComponent).init();
        let inst = DisplayComponent.get(HighlightFramesComponent).getInstance();
        this.reelFrame.addChild(inst);
    }

    private async setupReelFrame(doAnimate: boolean): Promise<void> {

        const reelBack = Sprite.from("reelBackBase");
        reelBack.anchor = 0.5;
        this.reelFrame.label = "bg_reelframe";
        reelBack.position.set(-96, 113);
        this.reelFrame.addChild(reelBack);

        this.reels.position.set(-473, -124);
        this.setupHighlightFrames();
        this.reelFrame.addChild(this.reels);

        this.game.addChild(this.reelFrame);
        this.setupCharacter();
        this.logo.alpha = 0;
        this.reelFrame.alpha = 0;
        DisplayComponent.get(CharacterComponent).getInstance().alpha = 0;
        this.backgroundImageCont.alpha = 0;
        this.backgroundSpine.alpha = 0;


        this.setupIntro();

        this.game.addChild(this.logo);
        this.logo.state.setAnimation(0, "animation", true);

        this.backgroundSpine.state.setAnimation(0, "animation", true); // idle ANIMATION

        if (doAnimate) {

            //put reel logo mult on top

            this.gameIntro.state.addListener({
                start: () => {

                    const bgAlphaTime = setTimeout(() => {
                        this.logo.alpha = 1;
                        this.reelFrame.alpha = 1;
                        // this.character?.alpha = 1;
                        DisplayComponent.get(CharacterComponent).getInstance().alpha = 1;
                        this.backgroundImageCont.alpha = 1;
                        this.backgroundSpine.alpha = 1;

                        clearTimeout(bgAlphaTime);
                    }, 100);

                },
                // event: (_entry, event) => {
                //     if (event.data.name === "logo_appear") {
                //         this.logoIntroAnimation();
                //     }
                // },
                complete: async () => {
                    this.onIntroComplete();

                }
            });
            // await wait(200);
            this.gameIntro.eventMode = 'static';
            this.gameIntro.interactive = true;
            this.gameIntro?.on("pointerup", this.onIntroComplete, this);
            this.gameIntro.state.setAnimation(0, "game_intro", false);
            sound.play("Intro_transition");
        }
        else {

            this.removeChild(this.gameIntro);
            this.gameIntro.destroy(true);
            this.gameIntro = null;


            this.logo.alpha = 1;
            this.reelFrame.alpha = 1;
            //this.character?.alpha = 1;
            DisplayComponent.get(CharacterComponent).getInstance().alpha = 1;
            this.backgroundImageCont.alpha = 1;
            this.backgroundSpine.alpha = 1;
        }
    }

    private onIntroComplete() {
        this.gameIntro?.off("pointerup", this.onIntroComplete, this);
        this.gameIntro.state.clearListeners();
        sound.stop("Intro_transition");
        this.removeChild(this.gameIntro);
        this.gameIntro.destroy(true);
        this.gameIntro = null;

        // this.logo.state.setAnimation(0, "logo_intro", false);

        this.setupBGSound();
        CasinoChannelHandler.reportGameStarted();
        setIsGameAlreadyLoaded(true);
    }

    public update(): void {
        tweenGroup?.update();
        this.reels?.update();
        // this.banner?.update();
        this.bigWin?.update();
    }

    public resize(screenWidth: number, screenHeight: number): void {

        let scale: number;

        let bgScale;
        const BG_SCALE_FACTOR = Math.max(screenWidth / 3000, screenHeight / 3000);


        if (screenWidth > screenHeight) {

            scale = 1 * Math.min(screenWidth / 1920, screenHeight / 1080);
            bgScale = Math.max(scale, BG_SCALE_FACTOR);

            this.game.scale.set(scale, scale);

            const xPos = (3000 * scale - screenWidth) / 2;
            const yPos = ((3000 + 0) * scale - screenHeight) / 2;

            // this.y = -200 * scale;

            this.game.x = -xPos;
            this.game.y = -yPos;

            this.reelFrame.scale = 1;
            this.reelFrame.position.set(1538, 1255);

            this.logo.scale = logoPositionLandscape.scale;
            this.logo.position.set(logoPositionLandscape.x, logoPositionLandscape.y);

            this.backgroundImageCont.scale.set(bgScale, bgScale)
            const bgXPos = (3000 * bgScale - screenWidth) / 2;
            const bgYPos = (3000 * bgScale - screenHeight) / 2;
            this.backgroundImageCont.position.set(-bgXPos, -bgYPos);

            if (this.gameIntro) {

                this.addChild(this.gameIntro);
                this.gameIntro.scale.set(bgScale, bgScale)
                const bgXPos = screenWidth / 2;
                const bgYPos = screenHeight / 2;
                this.gameIntro.position.set(bgXPos, bgYPos);
            }

        }
        else {


            scale = 1 * Math.min(screenWidth / 1080, screenHeight / 1920);
            bgScale = Math.max(scale, BG_SCALE_FACTOR);

            this.game.scale.set(scale, scale);

            const xPos = (3000 * scale - screenWidth) / 2;
            const yPos = ((3000 + 0) * scale - screenHeight) / 2;

            // this.y = -300 * scale;

            this.game.x = -xPos;
            this.game.y = -yPos;

            this.reelFrame.scale = 1;
            this.reelFrame.position.set(1538, 1255);

            this.logo.scale = logoPositionPortrait.scale;
            this.logo.position.set(logoPositionPortrait.x, logoPositionPortrait.y);

            this.backgroundImageCont.scale.set(bgScale, bgScale)
            const bgXPos = (3000 * bgScale - screenWidth) / 2;
            const bgYPos = (3000 * bgScale - screenHeight) / 2;
            this.backgroundImageCont.position.set(-bgXPos, -bgYPos);

            if (this.gameIntro) {
                this.addChild(this.gameIntro);
                this.gameIntro.scale.set(bgScale, bgScale)
                const bgXPos = screenWidth / 2;
                const bgYPos = screenHeight / 2;
                this.gameIntro.position.set(bgXPos, bgYPos);
            }

        }

        this.game.children.forEach(element => {
            if (element instanceof DisplayObject) {
                element.setPositionResize(Manager.Orientation);
            }
        });

        this.bigWin?.scale.set(scale, scale);
        this.bigWin?.position.set(screenWidth / 2, (screenHeight / 2) - 50 * scale);
        this.bigWin?.resize(screenWidth, screenHeight);

    }
}
